import { ContactMe } from "../types";

export const contactMe: ContactMe = {
  profilePicture: { url: "/images/me.jpg" },
  name: "Mikhil Anand",
  title: "AI Engineer & Computer Science Student",
  summary: `
    I'm passionate about combining AI/ML with software engineering to build intelligent, 
    scalable systems. From training neural networks to architecting cloud infrastructures, 
    I enjoy bringing machine learning from research to real-world applications.
  `,
  companyUniversity: "National University of Singapore",
  linkedinLink: "https://www.linkedin.com/in/mikhil-anand-aa593437/",
  email: "mikhilanand@gmail.com",
};
